import { createSlice } from "@reduxjs/toolkit";
// this code for slice value for  filter live
export const filterlive = createSlice({
  name: "filterlive",
  initialState: {
    isLoading: false,
    isSuccess: false,
    api_completed: false,
    isFirst: true,
    data: {},
  },
  reducers: {
    edit_filterlive: (state, action) => {
      state.data = action.payload;
    },
    success_api_call_filterlive: (state, action) => {
      state.data = action.payload;
      state.isLoading = false;
      state.isSuccess = true;
      state.api_completed = true;
      state.isFirst = true;
    },
    failure_api_call_filterlive: (state, action) => {
      state.isLoading = false;
      state.data = action.payload;
      state.api_completed = true;
      state.isSuccess = false;
    },
    filterlive_is_success: (state) => {
      state.isSuccess = false;
    },
    filterlive_complete_api: (state) => {
      state.api_completed = false;
    },
  },
});
export default filterlive.reducer;
export const {
  edit_filterlive,
  success_api_call_filterlive,
  filterlive_complete_api,
  failure_api_call_filterlive,
  filterlive_is_success,
} = filterlive.actions;
